// Uppy documentation (see https://uppy.io/docs/uppy/)
export const maxNumberOfFiles = 1;
export const maxFileSize = null;
export const allowedFileTypes = null;

export default {
  maxNumberOfFiles,
  maxFileSize,
  allowedFileTypes,
};
